var carouselTheme = {
  carousel: {
    arrows: {
      backgroundColor: '#FFFFFF',
      horizontal: {
        iconPrev: 'chevron-left',
        iconNext: 'chevron-right'
      },
      vertical: {
        iconPrev: 'chevron-up',
        iconNext: 'chevron-down'
      },
      default: {
        size: 22,
        iconSize: 10
      },
      lg: {
        size: 34,
        iconSize: 16
      },
      color: {
        default: '#1f3143',
        primary: '#1f3143'
      }
    },
    dots: {
      background: {
        default: '#C5C6C6',
        primary: 'transparent'
      },
      border: {
        default: 'transparent',
        primary: '#1B9DDB'
      },
      size: {
        default: 8,
        primary: 16
      }
    }
  }
};
export default carouselTheme;